export const ENCRYPTED_COOKIE = true;
// export const SITE_FALLBACK_URL = "https://www.mrasadatik.dev";
export const SITE_FALLBACK_NAME = "@mrasadatik";
export const SITE_FALLBACK_URL = "https://mrasadatik.vercel.app";
